import { createSelector } from '@reduxjs/toolkit';
import { State } from './types';
import { RootState } from '../root-reducer';

const rootSelector = (state: RootState): State => state.HelpInfos;

export const statusSelector = createSelector(rootSelector, (state) => state.status);

export const errorSelector = createSelector(rootSelector, (state) => state.error);

const dataSelector = createSelector(rootSelector, (state) => state.data);
const dataMessageAssistantSelector = createSelector(rootSelector, (state) => state.dataMessageAssistant);

export default {
  statusSelector,
  errorSelector,
  dataSelector,
  dataMessageAssistantSelector,
};
